<template>
  <ul class="status-item-group">
    <li
      v-for="(item, index) in items"
      :key="`status-item-group__item-${index}`"
      :class="{ 'ds-margin-bottom-24': items.length > 1 && index !== items.length - 1 }"
    >
      <StatusItem
        :icon="item.icon"
        :title="item.title"
        :date="item.date"
        :description="item.description"
        align-x="left"
        with-small-spacing
        is-aria-heading
        :with-vertical-line="index !== items.length - 1"
      />
    </li>
  </ul>
</template>

<script>
import StatusItem from './status-item';

export default {
  name: 'StatusItemGroup',
  components: { StatusItem },
  props: {
    items: { type: Array, required: true, validator: arr => arr.length }
  }
};
</script>
